<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
        <el-button type="success" @click="openAdd">新增</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
     <template #geo="{ row }">
        <div>
           <el-button type="primary" size="small" @click="openGeo(row)">查看</el-button>
        </div>
      </template>
      <template #handler="{ row }">
        <div>
           <el-button type="primary" size="small" @click="openEdit(row)">修改</el-button>
        </div>
      </template>
    </auto-table>

     <AddorEdit ref="add" @success="getList(1)"></AddorEdit>
     <areaMap ref="amap"></areaMap>
  </div>
</template>

<script>
import AddorEdit from './AddorEdit.vue';
import areaMap from './areaMap.vue';

export default {
    components:{
        AddorEdit,
        areaMap
    },
  data() {
    return {
      DataList: [],
      Option: [
        { name: "名称", value: "name" },
        { name: "分布图", value: "geo", type: "custom" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 1,
    };
  },

  mounted() {
     this.id = this.$route.query.id;
   
  },

  methods: {
    openGeo(row){
        this.$refs.amap.open(row)
    },
    init(){
      if(this.DataList.length == 0){
        this.getList(1);
      }
 
    },
    openAdd() {
       let comm =  { venue_id: this.id}
          this.$refs.add.open(comm)
    },
     openEdit(row) {
         this.$refs.add.open(row)
    },

    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/shared/venueArea/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          venue_id:this.id
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>